import { hasMegaMenu } from './descriptor.has-megamenu.js';
import { shouldTerminateMegaMenu } from './descriptor.should-terminate-megamenu.js';
import { findRenderedDescriptorByPath } from './path.find-rendered-descriptor.js';
import { findPageDescriptorById } from './util.find-page-descriptor-by-id.js';

function findSubNavigationRoot(state, path) {
  const currPageDescriptor = findRenderedDescriptorByPath(state, path);
  if (!currPageDescriptor) {
    return;
  }
  const parentDescriptors = recursivelyGetParentDescriptors(
    state,
    currPageDescriptor
  );
  const rootPageDescriptor = parentDescriptors[0];
  if (!hasMegaMenu(rootPageDescriptor)) {
    return rootPageDescriptor;
  }
  return parentDescriptors.find((it) => shouldTerminateMegaMenu(it)) ?? rootPageDescriptor;
}
function recursivelyGetParentDescriptors(state, pageDescriptor) {
  if (!pageDescriptor.parentId) {
    return [pageDescriptor];
  }
  const parentDescriptor = findPageDescriptorById(
    state,
    pageDescriptor.parentId
  );
  if (!parentDescriptor) {
    return [pageDescriptor];
  }
  return [
    ...recursivelyGetParentDescriptors(state, parentDescriptor),
    pageDescriptor
  ];
}

export { findSubNavigationRoot };
//# sourceMappingURL=descriptor.get-sub-navigation-root.js.map
